import { OrderTimelineEvent } from '@components/common/OrderTimelineEvent';
import { useTimelineQuery } from '@modules/Dashboard/Contributions/queries/useTimelineQuery';
import React from 'react';
export const useOrderTimelineEvents = (orderId) => {
    const { timelineQuery } = useTimelineQuery([orderId]);
    const events = timelineQuery.data?.events?.map((timelineEvent) => ({
        ...timelineEvent,
        description: React.createElement(OrderTimelineEvent, { timelineEvent: timelineEvent }),
    })) || [];
    const fulfillments = timelineQuery?.data?.fulfillments
        ?.filter((timelineFulfillment) => timelineFulfillment.shipments[0]?.deliveryEstimate)
        .map((timelineFulfillment) => ({
        id: timelineFulfillment.fulfillmentId,
        description: React.createElement(OrderTimelineEvent, { timelineFulfillment: timelineFulfillment }),
    })) || [];
    return { timelineEvents: [...fulfillments, ...events], isLoading: timelineQuery.isLoading };
};
